import { ElementFinder } from "protractor";
import { ENERGY_SERVICES, FILTERS_DICT } from "./const";
// export const apiVersion = '/api/v1';
// export const URLAPI = apiURL + apiVersion;

// export const clientURLPROD = 'https://dev-dashboard.ncsa.ch';
// export const clientURLDEV = 'http://localhost:4200';
// export const clientURL = clientURLPROD

/* CHART IDS */
export const idChartEvolution = "evolution";
export const idChartEvolutionStratData = "evolution_strategy_data";
export const idChartRenewableBarChart = "renewable_bar";
export const idChartRenewableBarChartEnAbs = "renewable_bar_energy_absolute";
export const idChartRenewableBarChartEnPct = "renewable_bar_energy_pourcent";
export const idChartRenewableBarChartElec = "renewable_bar_electricity";
export const idChartRenewableBarChartHeat = "renewable_bar_heat";
export const idChartRenewableBarChartMobility = "renewable_bar_mobility";
export const idChartLocalBarChart = "local_bar";
export const idChartMixBarChart = "mix_bar";
export const idChartEvolutionCO2Habitant = "evolution_co2_habitant";
export const idChartEvolutionCO2MobilityHabitant = "evolution_co2_mobility_habitant";
export const idChartEvolutionEnergyElectricityHabitant =
  "evolution_energy_electricity_habitant";
export const idChartActual = "actual";
export const idChartActualCO2Habitant = "actual_co2_habitant";
export const idChartActualCO2MobilityHabitant = "actual_co2_mobility_habitant";
export const idChartActualEnergyElectricityHabitant =
  "actual_energy_electricity_habitant";
export const idChartMix = "mix";
export const idChartMixStratData = "mix_strategy_data";
export const idChartRenewable = "renewable";
export const idChartRenewableStratData = "renewable_strategy_data";
export const idChartLocal = "local";
export const idChartLocalStratData = "local_strategy_data";
export const idChartStrategy = "global-strategy-area";
export const idChartStrategyElec = "elec-strategy-area";
export const idChartStrategyElecRefMesObj = "elec-strategy-area-ref-mes-obj";
export const idChartStrategyHeat = "heat-strategy-area";
export const idChartStrategyHeatAbs = "heat-strategy-area-abs";
export const idChartStrategyHeatEnAbs = "heat-strategy-area-en-abs";
export const idChartStrategyHeatRefMesObj = "heat-strategy-area-ref-mes-obj";
export const idChartStrategyBuilding = "building-strategy-area";
export const idChartStrategyBuildingRefMesObj = "building-strategy-area-ref-mes-obj";
export const idChartStrategyMobility = "mobility-strategy-area";
export const idChartVechiculeFuelNb = "mobility-fuel-vehicles";
export const idChartVechiculeFuelNbOnlyAmount = "mobility-fuel-vehicles-only-amount";
export const idChartVechiculeFuelNbAllFuelsAbsolute =
  "mobility-fuel-vehicles-all-fuels-absolute";
export const idChartVechiculeEnergyGhgBar = "mobility-fuel-vehicles-energy-ghg-bar";
export const idChartVechiculeEnergyAbs = "mobility-fuel-vehicles-absolute-energy";
export const idChartVechiculeTypeNb = "nb-vehicles-type";
export const idChartNetworksGeneral = "networks-general";
export const idChartRenHeatDoughnut = "ren_doughnut_heat";
export const idChartRenElecDoughnut = "ren_doughnut_elec";
export const idChartRenMobilityDoughnut = "ren_doughnut_mobility";
export const idChartElecProductConsumption = "electricity-consumption";
export const idChartRenEnergyProd = "ren-energy-prod";
export const idChartActions = "actions-general";
export const idChartSubsidies = "subsidies";
export const idChartS2000W = "s2000W";
export const idChartPublicBdg = "public-building";
export const idChartHeaterSubstitution = "heater_substitution";
export const idChartHeaterSubstitutionNbRenewable = "heater_substitution_number_renewable";

export const idChartRenewableHeaterSubstitutionEnergy =
  "renewable_heater_substitution_in_energy";
export const idChartRenewableHeaterSubstitutionEnergyCumulated =
  "renewable_heater_substitution_in_energy_cumulated";
export const idChartRenewableHeaterSubstitutionEnergyWithLineAnualTarget = 
  "renewable_heater_substitution_in_energy_with_line_anual_target";
export const idChartRenewableHeaterSubstitutionEnergyNotDetailedWithoutAnnualTarget =
  "renewable_heater_substitution_in_energy_not_detailed_without_annual_target";
export const idChartHeatCoveredByDhnNewNeedsByYear =
  "heat_covered_by_dhn_new_needs_by_year";
export const idChartHeatCoveredByDhnCumulatedNeeds =
  "heat_covered_by_dhn_cumulated_needs";
export const idAnualHeatCoveredByDhnWithFinalTarget = "anual_heat_covered_by_dhn_with_final_target";
export const idCumulatedHeatCoveredByDhnWithFinalTarget = "cumulated_heat_covered_by_dhn_with_final_target";
export const idChartElecProd = "electricity_production";
export const idChartElecProdWithRatioPotWithoutInj = "electricity_production_with_ratio_potential_used_without_injection";
export const idChartElecProdWithRatioPotWithoutInjAbs = "electricity_production_with_ratio_potential_used_without_injection_abs";
export const idChartPvTarget = "target_value_pv";
export const idPublicConsumptionByBuildingType =
  "public_consumption_by_building_type";
export const idPublicConsumptionByEnergeticAgent =
  "public_consumption_by_energetic_agent";
export const idPublicConsumptionByBuildingTypeAllTypes =
  "public_consumption_by_building_type_all_types";
export const idPublicConsumptionByEnergeticAgentAllAgents =
  "public_consumption_by_energetic_agent_all_agents";
export const idMinergieNew = "minergie_chart_new";
export const idMinergieRenovation = "minergie_chart_renovation";
export const idMinergieStack = "minergie_chart_stack";
export const idCyclingPaths = "cycling_paths";
export const idParkingSpaces = "parking_spaces";
export const idElectricityHouseholdConsumption =
  "electricity_household_consumption";
export const idElectricityConsumptionWithAutoconsAndObjAbs =
  "electricity_cons_chart_with_autocons_and_obj_abs";
export const idPublicLightingNoTarget = "public_lighting_consumption";
export const idPublicLightingNoTargetAbsolute = "public_lighting_consumption_absolute";
export const idRenovationPercentageTarget = "renovation_percentage_target";
export const idRenovationAreaTarget = "renovation_area_target";
export const idRenovationAreaTargetWithoutDetails = "renovation_area_target_without_details";
export const idRenovationAreaTargetAnualData = "renovation_area_target_anual_data";
export const idAnnualRenovationAreaWithFinalTarget = "annual_renovation_area_with_final_target";
export const idAnnualRenovationAreaWithOutFinalTarget = "annual_renovation_area_without_final_target";
export const idCumulatedRenovationAreaWithFinalTarget = "cumulated_renovation_area_with_final_target";
export const idCumulatedRenovationAreaWithOutFinalTarget = "cumulated_renovation_area_without_final_target";

export const idRenovationChartData = "renovation_chart_data";
export const idLocalElectricityTarget = "local_electricity_target";
export const idPvInstallationTarget = "pv_installation_target";
export const idPvInstallationTargetPotential = "pv_installation_target_and_potentiel";
export const idPvInstallationTargetDetailed = "pv_installation_target_detailed";
export const idPvAreaTargetDetailedWithoutAnnualTarget =
  "pv_area_target_detailed_without_annual_target";
export const idPvAreaTargetDetailedWithoutAnnualTargetAbsolute =
  "pv_area_target_detailed_without_annual_target_absolute";
export const idPvAreaTargetNotDetailedWithoutAnnualTargetAbsolute =
  "pv_area_target_not_detailed_without_annual_target_absolute";
export const idPvAreaDetailedWithLineAnualTargetAbsolute ="pv_area_chart_detailed_with_line_anual_target_absolute";
export const idAnualPvAreaWithFinalTarget = "anual_pv_area_with_final_target";
export const idCumulatedPvAreaWithFinalTarget = "cumulated_pv_area_with_final_target";
export const idSubsidiesCount = "subsidies_count";
export const idMotorization = "motorization";
export const idChartRenewableHeatConsumption = "renewable_heat_consumption";
export const idAnualRenewableSubstitutionEnergyWithFinalTarget = "anual_renewable_substitution_energy_with_final_target";
export const idCumulatedRenewableSubstitutionEnergyWithFinalTarget = "cumulated_renewable_substitution_energy_with_final_target";
export const idChartRenewableHeatConsumptionWithoutEmptyMeasures =
  "renewable_heat_consumption_without_empty_measures";
export const idChartRenewableHeatConsumptionWithoutEmptyYears =
  "renewable_heat_consumption_without_empty_years";
export const idChartRenewableHeatConsumptionWithAllProjections =
  "renewable_heat_consumption_with_all_projections";
export const idChartRenewableHeatConsumptionWithAllProjectionsWithoutEmptyMeasures =
  "renewable_heat_consumption_with_all_projections_without_empty_measures";
export const idChartRenewableHeatConsumptionWithAllProjectionsWithoutEmptyYears =
  "renewable_heat_consumption_with_all_projections_without_empty_years";
export const idChartRenewableElectricityConsumption =
  "renewable_electricity_consumption";
export const idChartRenewableElectricityConsumptionWithoutEmptyMeasures =
  "renewable_electricity_consumption_without_empty_measures";
export const idChartRenewableElectricityConsumptionWithoutEmptyYears =
  "renewable_electricity_consumption_without_empty_years";
export const idChartRenewableElectricityConsumptionWithAllProjections =
  "renewable_electricity_consumption_with_all_projections";
export const idChartRenewableElectricityConsumptionWithAllProjectionsWithoutEmptyMeasures =
  "renewable_electricity_consumption_with_all_projections_without_empty_measures";
export const idChartRenewableElectricityConsumptionWithAllProjectionsWithoutEmptyYears =
  "renewable_electricity_consumption_with_all_projections_without_empty_years";
export const idChartRenewableHeatElecConsumption =
  "renewable_heat_elec_consumption";
export const idChartRenewableHeatElecMobilityConsumption =
  "renewable_heat_elec_mobility_consumption";
export const idChartRenewableHeatElecMobilityConsumptionNonEmptyProj =
  "renewable_heat_elec_mobility_consumption_nonemptyproj";
export const idChartScope12_3Abs =
  "evolution_scope_12_3_co2_abs"
export const idChart2000WPrimaryEnergy =
"obj_2000w_prim_en_pct";
export const idChart2000WCO2 =
"obj_2000w_prim_co2_pct";
export const idChart2000WRenewableHeat =
"obj_2000w_prim_ren_heat_pct";
export const idChart2000WRenewableElec =
"obj_2000w_prim_ren_elec_pct";
export const idGhgBalance = "co2_balance";
export const idGhgBalanceOnlySectors = "co2_balance_only_sectors_filters";
export const idGhgBalancePubAdministration = "co2_balance_public_administration";
export const idAvoidGhgBalancePubAdministration = "avoid_co2_balance_public_administration";
export const idAvoidGhgBalancePubAdministrationLineCumulated = "avoid_co2_balance_public_administration_line_cumulated";
export const idChartWaterConsumption = "water_consumption_chart"

export const genericChartIds = [
  "generic_chart",
  idElectricityHouseholdConsumption,
  idElectricityConsumptionWithAutoconsAndObjAbs,
  idRenovationPercentageTarget,
  idLocalElectricityTarget,
  idPvInstallationTarget,
  idPvInstallationTargetPotential,
  idPvInstallationTargetDetailed,
  idSubsidiesCount,
  idPublicLightingNoTarget,
  idPublicLightingNoTargetAbsolute,
  idMotorization,
  idPvAreaTargetDetailedWithoutAnnualTarget,
  idPvAreaTargetDetailedWithoutAnnualTargetAbsolute,
  idPvAreaTargetNotDetailedWithoutAnnualTargetAbsolute,
  idPvAreaDetailedWithLineAnualTargetAbsolute,
  idAnualPvAreaWithFinalTarget,
  idCumulatedPvAreaWithFinalTarget,
  idChartHeaterSubstitution,
  idChartHeaterSubstitutionNbRenewable,
  idChartRenewableHeaterSubstitutionEnergy,
  idChartRenewableHeaterSubstitutionEnergyCumulated,
  idChartRenewableHeaterSubstitutionEnergyWithLineAnualTarget,
  idChartRenewableHeaterSubstitutionEnergyNotDetailedWithoutAnnualTarget,
  idChartHeatCoveredByDhnNewNeedsByYear,
  idChartHeatCoveredByDhnCumulatedNeeds,
  idAnualHeatCoveredByDhnWithFinalTarget,
  idCumulatedHeatCoveredByDhnWithFinalTarget,
  idRenovationAreaTarget,
  idRenovationAreaTargetWithoutDetails,
  idRenovationAreaTargetAnualData,
  idAnnualRenovationAreaWithFinalTarget,
  idAnnualRenovationAreaWithOutFinalTarget,
  idCumulatedRenovationAreaWithFinalTarget,
  idCumulatedRenovationAreaWithOutFinalTarget,
  idRenovationChartData,
  idChartRenewableHeatConsumption,
  idAnualRenewableSubstitutionEnergyWithFinalTarget,
  idCumulatedRenewableSubstitutionEnergyWithFinalTarget,
  idChartRenewableHeatConsumptionWithoutEmptyMeasures,
  idChartRenewableHeatConsumptionWithoutEmptyYears,
  idChartRenewableHeatConsumptionWithAllProjections,
  idChartRenewableHeatConsumptionWithAllProjectionsWithoutEmptyMeasures,
  idChartRenewableHeatConsumptionWithAllProjectionsWithoutEmptyYears,
  idChartRenewableElectricityConsumption,
  idChartRenewableElectricityConsumptionWithoutEmptyMeasures,
  idChartRenewableElectricityConsumptionWithoutEmptyYears,
  idChartRenewableElectricityConsumptionWithAllProjections,
  idChartRenewableElectricityConsumptionWithAllProjectionsWithoutEmptyMeasures,
  idChartRenewableElectricityConsumptionWithAllProjectionsWithoutEmptyYears,
  idChartRenewableHeatElecConsumption,
  idChartRenewableHeatElecMobilityConsumption,
  idChartRenewableHeatElecMobilityConsumptionNonEmptyProj,
  idChartScope12_3Abs,
  idPublicConsumptionByEnergeticAgent,
  idPublicConsumptionByEnergeticAgentAllAgents,
  idPublicConsumptionByBuildingType,
  idPublicConsumptionByBuildingTypeAllTypes,
  idChart2000WPrimaryEnergy,
  idChart2000WCO2,
  idChart2000WRenewableHeat,
  idChart2000WRenewableElec,
  idGhgBalance,
  idGhgBalanceOnlySectors,
  idGhgBalancePubAdministration,
  idAvoidGhgBalancePubAdministration,
  idAvoidGhgBalancePubAdministrationLineCumulated,
  idChartWaterConsumption,
];

/* ENERGY SERVICE FILTER OPTIONS */
export const heatEnergyService = "heat";
export const electricityEnergyService = "electricity";
export const mobilityEnergyService = "mobility";

/* ENERGY SERVICE FOR BUILDING FILTER OPTIONS */
export const heatEnergyService_bdg = "heat-bdg";
export const electricityEnergyService_bdg = "electricity-bdg";

/* ENERGY TYPE FILTER OPTIONS */
export const heatEnergyType = "heat";
export const electricityEnergyType = "electricity";

/* VEHICLE FUEL FILTER OPTIONS */
// export const totalVF = 'total';
export const gasolineVF = "gasoline";
export const dieselVF = "diesel";
export const hybridVF = "hybridVF";
export const elecVF = "elecVF";
export const gasVF = "gasVF";
export const h2VF = "h2VF";
export const otherVF = "otherVF";

/* VEHICLE TYPE FILTER OPTIONS */
// export const otherVehicleType = 'total';
export const carsVT = "car";
export const motorbikesVT = "motorbike";
export const scootersVT = "scooter";
export const trucksVT = "truck";
export const othersVT = "other";

/* GHG SCOPES */
export const scope_1 = "scope_1";
export const scope_2 = "scope_2";
export const scope_3 = "scope_3";

/* GHG EMISSION SECTORS */
export const stationary_energy = "stationary_energy";
export const transportation = "transportation";
export const electricity = "electricity";
export const industrial_process = "industrial_process";
export const building_infrastructure = "building_infrastructure";
export const mobility_infrastructure = "mobility_infrastructure";
export const consumer_goods = "consumer_goods";
export const agriculture = "agriculture";
export const waste = "waste";


/* SIA BUILDING ASSIGNMENT FILTER OPTIONS */
export const siaMultiDwelling = "sia_multi_dwelling";
export const siaIndividualDwelling = "sia_individual_dwelling";
export const siaAdministration = "sia_administration";
export const siaSchool = "sia_school";
export const siaBusiness = "sia_business";
export const siaRestaurant = "sia_restaurant";
export const siaGatheringPlace = "sia_gathering_place";
export const siaHospital = "sia_hospital";
export const siaIndustry = "sia_industry";
export const siaWarehouse = "sia_warehouse";
export const siaSportsFacility = "sia_sports_facility";
export const siaIndoorSwimmingPool = "sia_indoor_swimming_pool";

/* ENERGETIC AGENT FILTER OPTIONS */
export const eaSolar = "ea_solar";
export const eaGas = "ea_gas";
export const eaFuelOil = "ea_fuel_oil";
export const eaElectricity = "ea_electricity";
export const eaWood = "ea_wood";
export const eaHeatPump = "ea_heat_pump";
export const eaDHN = "ea_dhn";
export const eaOther = "ea_other_agent";

/* DEFAULT FILTER OPTION VALUES */
export const defaultTimeLine = "2016";
export const defaultSizeChart = 250;
export const defaultPanelSize = 440;
export const defaultIdDisplayed = 1;
export const defaultDataName = "DATA.regio";

// DASHBOARD
export const defaultDashboardType = "consommation";

// RADIO BUTTONS
// don't use const to avoid :error TS2367: when setting the default buttons
export let defaultValueType = "habitant";
export let defaultMoneyCO2 = "money";
export let defaultIndicator = "energy";
export let defaultPerimeter = "territory";
export let defaultNetworksInd = "global";
export let defaultActionCategory = "total";
export let defaultGhsScopesSectors = 'sectors';

// CHECKBOX BUTTONS
// default energy service is defined during the filter "setup"
export const defaultEnergyServiceBdg = [
  heatEnergyService_bdg,
  electricityEnergyService_bdg
];
export const defaultEnergyType = [heatEnergyType, electricityEnergyType];
export const defaultVehicleFuels = [
  gasolineVF,
  dieselVF,
  hybridVF,
  elecVF,
  gasVF,
  h2VF,
  otherVF
];
export const defaultVehicleTypes = [
  carsVT,
  motorbikesVT,
  scootersVT,
  trucksVT,
  othersVT
];
export const defaultSiaAssignment = [
  siaMultiDwelling,
  siaIndividualDwelling,
  siaAdministration,
  siaSchool,
  siaBusiness,
  siaRestaurant,
  siaGatheringPlace,
  siaHospital,
  siaIndustry,
  siaWarehouse,
  siaSportsFacility,
  siaIndoorSwimmingPool
];
export const defaultEnergeticAgent = [
  eaSolar,
  eaGas,
  eaFuelOil,
  eaElectricity,
  eaWood,
  eaHeatPump,
  eaDHN,
  eaOther
];
export const defaultGhgScopes = [
  scope_1,
  scope_2,
  scope_3
];

export const defaultGhgEmissionSectors = [
  stationary_energy,
  transportation,
  electricity,
  industrial_process,
  building_infrastructure,
  mobility_infrastructure,
  consumer_goods,
  agriculture,
  waste
];

/* FILTER TRANSLATION SETTING */
export const translateFilterType = "FILTERS.TYPE.";
export const translateFilterMoneyVsCO2 = "FILTERS.MONEYORSAVEDCO2.";
export const translateFilterTypeIndVehicles = "FILTERS.TYPEINDVEHICLES.";
export const translateFilterValue = "FILTERS.VALEURS.";
export const translateFilterEnergie = "FILTERS.ENERGIE.";
export const translateFilterPerimeter = "FILTERS.PERIMETER.";
export const translateFilterNetworksInd = "FILTERS.NETWORKIND.";
export const translateFilterVehicleFuel = "FILTERS.VEHICLEFUELS.";
export const translateFilterVehicleType = "FILTERS.VEHICLETYPES.";
export const translateFilterActionCategory = "FILTERS.ACTIONCATEGORY.";
export const translateFilterSiaAssignment = "FILTERS.SIAASSIGNMENT.";
export const translateFilterEnergeticAgent = "FILTERS.ENERGETICAGENT.";
export const translateFilterScopesSectors = "FILTERS.SCOPES_SECTORS.";
export const translateFilterGhgScopes = "FILTERS.GHGSCOPES.";
export const translateFilterGhgEmissionSector = "FILTERS.EMISSIONSECTORS.";
/* FILTER SETUP -> Create the list containing all the buttons for the filter */
/* ENERGY SERVICE FILTER SETUP */
//export const defaultEnergyService = [electricityEnergyService, heatEnergyService];
var enServiceList: any = [];
var enServiceListButt: any = [];
for (var enService in ENERGY_SERVICES) {
  if (ENERGY_SERVICES[enService]["id"] == "electricity") {
    var classButton = "button-elec";
    var translateService = translateFilterEnergie + "ELECT";
  } else if (ENERGY_SERVICES[enService]["id"] == "mobility") {
    var classButton = "button-mobil";
    var translateService = translateFilterEnergie + "MOBILITE";
  } else if (ENERGY_SERVICES[enService]["id"] == "heat") {
    var classButton = "button-heat";
    var translateService = translateFilterEnergie + "CHALEUR";
  }
  enServiceList.push(ENERGY_SERVICES[enService]["id"]);
  enServiceListButt.push({
    id: ENERGY_SERVICES[enService]["id"],
    class: classButton,
    selected: true,
    translate: translateService
  });
}
export const buttonsEnergyService: any = enServiceListButt;
export const defaultEnergyService = enServiceList;

/* ENERGY SERVICE FOR BUILDING FILTER SETUP */
var enServiceListForBdg: any = [];
for (var enService in defaultEnergyServiceBdg) {
  if (defaultEnergyServiceBdg[enService] == electricityEnergyService_bdg) {
    var classButton = "button-elec";
    var translateService = translateFilterEnergie + "ELECT";
  } else if (defaultEnergyServiceBdg[enService] == heatEnergyService_bdg) {
    var classButton = "button-heat";
    var translateService = translateFilterEnergie + "CHALEUR";
  }
  var idButton = defaultEnergyServiceBdg[enService];
  enServiceListForBdg.push({
    id: idButton,
    class: classButton,
    selected: false,
    translate: translateService
  });
}
export const buttonsEnergyServiceForBdg: any = enServiceListForBdg;

/* ENERGY TYPE FILTER SETUP */
var energyType: any = [];
for (var enType in defaultEnergyType) {
  if (defaultEnergyType[enType] == electricityEnergyType) {
    var classButton = "button-elec";
    var translateService = translateFilterEnergie + "ELECT";
  } else if (defaultEnergyType[enType] == heatEnergyType) {
    var classButton = "button-heat";
    var translateService = translateFilterEnergie + "CHALEUR";
  }
  var idButton = defaultEnergyType[enType];
  energyType.push({
    id: idButton,
    class: classButton,
    selected: false,
    translate: translateService
  });
}
export const buttonsEnergyType: any = energyType;

/* VALUE TYPE FILTER SETUP */
export const buttonsValueType: any = [
  {
    id: "habitant",
    name: "Valeurs / habitant",
    translate: translateFilterValue + "HABITANT",
    selected: defaultValueType == "habitant"
  },
  {
    id: "absolute",
    name: "Valeurs absolues",
    translate: translateFilterValue + "ABSOLUE",
    selected: defaultValueType == "absolute"
  },
  {
    id: "pourcent",
    name: "%",
    translate: translateFilterValue + "POURCENT",
    selected: defaultValueType == "pourcent"
  }
];

/* INDICATOR FILTER SETUP */
export const buttonsIndicator: any = [
  {
    id: "energy",
    name: "Energie",
    translate: translateFilterType + "ENERGY",
    selected: defaultIndicator == "energy"
  },
  {
    id: "co2",
    name: "CO2",
    translate: translateFilterType + "CO2",
    selected: defaultIndicator == "co2"
  }
];

export const buttonsMoneySavedCO2: any = [
  {
    id: "money",
    name: "Money",
    translate: translateFilterMoneyVsCO2 + "MONEY",
    selected: defaultMoneyCO2 == "money"
  },
  {
    id: "co2_saved",
    name: "Saved_CO2",
    translate: translateFilterMoneyVsCO2 + "CO2",
    selected: defaultMoneyCO2 == "co2"
  }
]

/* INDICATOR VECHICLES FILTER SETUP*/
export const buttonsIndicatorsVehicles: any = [
  {
    id: "energy",
    name: "Energie",
    translate: translateFilterTypeIndVehicles + "ENERGY",
    selected: defaultIndicator == "energy"
  },
  {
    id: "co2",
    name: "CO2",
    translate: translateFilterTypeIndVehicles + "CO2",
    selected: defaultIndicator == "co2"
  },
  {
    id: "nb",
    name: "Number",
    translate: translateFilterTypeIndVehicles + "NUMBER",
    selected: defaultIndicator == "nb"
  }
];

/* NETWORK INDICATOR FILTER SETUP */
export const buttonsNetworksIndService: any = [
  {
    id: "global",
    name: "Global_network",
    translate: translateFilterNetworksInd + "GLOBAL",
    selected: defaultNetworksInd == "global"
  },
  {
    id: "mix-test",
    name: "Mix_network",
    translate: translateFilterNetworksInd + "MIX",
    selected: defaultNetworksInd == "mix-test"
  },
  {
    id: "CO2_red",
    name: "CO2Red_Network",
    translate: translateFilterNetworksInd + "CO2RED",
    selected: defaultNetworksInd == "CO2_red"
  }
];

/* PERIMETER FILTER SETUP */
export const buttonsPerimeterService: any = [
  {
    id: "territory",
    name: "Territory",
    translate: translateFilterPerimeter + "TERRITORY",
    selected: defaultPerimeter == "territory"
  },
  {
    id: "municipality",
    name: "Municipality",
    translate: translateFilterPerimeter + "MUNICIPALITY",
    selected: defaultPerimeter == "municipality"
  }
];

/* ACTION CATEGORY FILTER SETUP */
export const buttonsActionCategory: any = [
  {
    id: "total",
    name: "Total",
    translate: translateFilterActionCategory + "TOTAL",
    selected: defaultActionCategory == "total"
  },
  {
    id: "municipality",
    name: "Municipality",
    translate: translateFilterActionCategory + "MUNICIPALITY",
    selected: defaultActionCategory == "municipality"
  },
  {
    id: "fund",
    name: "Fund",
    translate: translateFilterActionCategory + "FUND",
    selected: defaultActionCategory == "fund"
  }
];

/* SIA ASSIGNMENT FILTER SETUP */
var siaAssignmentList: any = [];
for (var assignment in defaultSiaAssignment) {
  switch (defaultSiaAssignment[assignment]) {
    case siaMultiDwelling:
      var classButton = "button-siaMultiDwelling";
      var translateAssignment = translateFilterSiaAssignment + "MULTI_DWELLING";
      break;

    case siaIndividualDwelling:
      var classButton = "button-siaIndividualDwelling";
      var translateAssignment =
        translateFilterSiaAssignment + "INDIVIDUAL_DWELLING";
      break;

    case siaAdministration:
      var classButton = "button-siaAdministration";
      var translateAssignment = translateFilterSiaAssignment + "ADMINISTRATION";
      break;

    case siaSchool:
      var classButton = "button-siaSchool";
      var translateAssignment = translateFilterSiaAssignment + "SCHOOL";
      break;

    case siaBusiness:
      var classButton = "button-siaBusiness";
      var translateAssignment = translateFilterSiaAssignment + "BUSINESS";
      break;

    case siaRestaurant:
      var classButton = "button-siaRestaurant";
      var translateAssignment = translateFilterSiaAssignment + "RESTAURANT";
      break;

    case siaGatheringPlace:
      var classButton = "button-siaGatheringPlace";
      var translateAssignment =
        translateFilterSiaAssignment + "GATHERING_PLACE";
      break;

    case siaHospital:
      var classButton = "button-siaHospital";
      var translateAssignment = translateFilterSiaAssignment + "HOSPITAL";
      break;

    case siaIndustry:
      var classButton = "button-siaIndustry";
      var translateAssignment = translateFilterSiaAssignment + "INDUSTRY";
      break;

    case siaWarehouse:
      var classButton = "button-siaWarehouse";
      var translateAssignment = translateFilterSiaAssignment + "WAREHOUSE";
      break;

    case siaSportsFacility:
      var classButton = "button-siaSportsFacility";
      var translateAssignment =
        translateFilterSiaAssignment + "SPORTS_FACILITY";
      break;

    case siaIndoorSwimmingPool:
      var classButton = "button-siaIndoorSwimmingPool";
      var translateAssignment =
        translateFilterSiaAssignment + "INDOOR_SWIMMING_POOL";
      break;
  }
  siaAssignmentList.push({
    id: defaultSiaAssignment[assignment],
    class: classButton,
    selected: false,
    translate: translateAssignment
  });
}
export const buttonsSiaAssignment: any = siaAssignmentList;

/* ENERGETIC AGENT FILTER SETUP */
var energeticAgentList: any = [];
for (var agent in defaultEnergeticAgent) {
  switch (defaultEnergeticAgent[agent]) {
    case eaSolar:
      var classButton = "button-eaSolar";
      var translateEA = translateFilterEnergeticAgent + "SOLAR";
      break;

    case eaGas:
      var classButton = "button-eaGas";
      var translateEA = translateFilterEnergeticAgent + "GAS";
      break;

    case eaFuelOil:
      var classButton = "button-eaFuelOil";
      var translateEA = translateFilterEnergeticAgent + "FUEL_OIL";
      break;

    case eaElectricity:
      var classButton = "button-eaElectricity";
      var translateEA = translateFilterEnergeticAgent + "ELECTRICITY";
      break;

    case eaWood:
      var classButton = "button-eaWood";
      var translateEA = translateFilterEnergeticAgent + "WOOD";
      break;

    case eaHeatPump:
      var classButton = "button-eaHeatPump";
      var translateEA = translateFilterEnergeticAgent + "HEAT_PUMP";
      break;

    case eaDHN:
      var classButton = "button-eaDHN";
      var translateEA = translateFilterEnergeticAgent + "DHN";
      break;

    case eaOther:
      var classButton = "button-eaOther";
      var translateEA = translateFilterEnergeticAgent + "OTHER";
      break;
  }
  energeticAgentList.push({
    id: defaultEnergeticAgent[agent],
    class: classButton,
    selected: false,
    translate: translateEA
  });
}
export const buttonsEnergeticAgent: any = energeticAgentList;

/* GHG SCOPES OR SECTORS SETUP */
export const buttonsScopesSectors: any = [
  {
    id: "scopes",
    name: "Scopes",
    translate: translateFilterScopesSectors + "SCOPES",
    selected: defaultGhsScopesSectors == "scopes",
    class: "button-scopes"
  },
  {
    id: "sectors",
    name: "Sectors",
    translate: translateFilterScopesSectors + "SECTORS",
    selected: defaultGhsScopesSectors == "sectors",
    class: "button-sectors"
  }
]

/* GHG SCOPES FILTER SETUP */
export const buttonsGhgScopes: any = [
  {
    id: "scope_1",
    name: "Scope_1",
    translate: translateFilterGhgScopes + "SCOPE_1",
    selected: scope_1 == "scope_1",
    class: "button-scope_1"
  },
  {
    id: "scope_2",
    name: "Scope_2",
    translate: translateFilterGhgScopes + "SCOPE_2",
    selected: scope_2 == "scope_2",
    class: "button-scope_2"
  },
  {
    id: "scope_3",
    name: "Scope_3",
    translate: translateFilterGhgScopes + "SCOPE_3",
    selected: scope_3 == "scope_3",
    class: "button-scope_3"
  }
]

/* GHG EMISSION SECTORS FILTER SETUP */
export const buttonsEmissionSectors: any = [
  {
    id: "stationary_energy",
    translate: translateFilterGhgEmissionSector + "STATIONARY_ENERGY",
    selected: stationary_energy == "stationary_energy",
    class: "button-stationary_energy"
  },
  {
    id: "transportation",
    translate: translateFilterGhgEmissionSector + "TRANSPORTATION",
    selected: transportation == "transportation",
    class: "button-transportation"
  },
  {
    id: "electricity",
    translate: translateFilterGhgEmissionSector + "ELECTRICITY",
    selected: electricity == "electricity",
    class: "button-electricity"
  },
  {
    id: "industrial_process",
    translate: translateFilterGhgEmissionSector + "INDUSTRIAL_PROCESS",
    selected: industrial_process == "industrial_process",
    class: "button-industrial_process"
  },
  {
    id: "building_infrastructure",
    translate: translateFilterGhgEmissionSector + "BUILDING_INFRASTRUCTURE",
    selected: building_infrastructure == "building_infrastructure",
    class: "button-building_infrastructure"
  },
  {
    id: "mobility_infrastructure",
    translate: translateFilterGhgEmissionSector + "MOBILTY_INFRASTRUCTURE",
    selected: mobility_infrastructure == "mobility_infrastructure",
    class: "button-mobility_infrastructure"
  },
  {
    id: "agriculture",
    translate: translateFilterGhgEmissionSector + "AGRICULTURE",
    selected: agriculture == "agriculture",
    class: "button-agriculture"
  },
  {
    id: "waste",
    translate: translateFilterGhgEmissionSector + "WASTE",
    selected: waste == "waste",
    class: "button-waste"
  },
  {
    id: "consumer_goods",
    translate: translateFilterGhgEmissionSector + "CONSUMER_GOODS",
    selected: consumer_goods == "consumer_goods",
    class: "button-consumer_goods"
  }
]

/* VEHICLE FUEL FILTER SETUP */
var vehiclefuelsList: any = [];
for (var vf in defaultVehicleFuels) {
  /* if (defaultVehicleFuels[vf] == totalVF){
    var classButton = 'button-allvf';
    var translateFuel = translateFilterVehicleFuel + 'TOTAL';
  } */
  if (defaultVehicleFuels[vf] == gasolineVF) {
    var classButton = "button-gasolinevf";
    var translateFuel = translateFilterVehicleFuel + "GASOLINE";
  } else if (defaultVehicleFuels[vf] == dieselVF) {
    var classButton = "button-dieselvf";
    var translateFuel = translateFilterVehicleFuel + "DIESEL";
  } else if (defaultVehicleFuels[vf] == elecVF) {
    var classButton = "button-elecvf";
    var translateFuel = translateFilterVehicleFuel + "ELEC";
  } else if (defaultVehicleFuels[vf] == gasVF) {
    var classButton = "button-gasvf";
    var translateFuel = translateFilterVehicleFuel + "GAS";
  } else if (defaultVehicleFuels[vf] == hybridVF) {
    var classButton = "button-hybridvf";
    var translateFuel = translateFilterVehicleFuel + "HYBRID";
  } else if (defaultVehicleFuels[vf] == otherVF) {
    var classButton = "button-othervf";
    var translateFuel = translateFilterVehicleFuel + "OTHERS";
  } else if (defaultVehicleFuels[vf] == h2VF) {
    var classButton = "button-h2vf";
    var translateFuel = translateFilterVehicleFuel + "H2";
  }
  vehiclefuelsList.push({
    id: defaultVehicleFuels[vf],
    class: classButton,
    selected: false,
    translate: translateFuel
  });
}
export const buttonsVehicleFuelService: any = vehiclefuelsList;

/* VEHICLE TYPE FILTER SETUP */
var vehicleTypesList: any = [];
for (var vt in defaultVehicleTypes) {
  if (defaultVehicleTypes[vt] == carsVT) {
    var classButton = "button-carsvt";
    var translateType = translateFilterVehicleType + "CAR";
  } else if (defaultVehicleTypes[vt] == motorbikesVT) {
    var classButton = "button-motorbikevt";
    var translateType = translateFilterVehicleType + "MOTORBIKE";
  } else if (defaultVehicleTypes[vt] == scootersVT) {
    var classButton = "button-scootervt";
    var translateType = translateFilterVehicleType + "SCOOTER";
  } else if (defaultVehicleTypes[vt] == trucksVT) {
    var classButton = "button-truckvt";
    var translateType = translateFilterVehicleType + "TRUCK";
  } else if (defaultVehicleTypes[vt] == othersVT) {
    var classButton = "button-othervt";
    var translateType = translateFilterVehicleType + "OTHER";
  }
  vehicleTypesList.push({
    id: defaultVehicleTypes[vt],
    class: classButton,
    selected: false,
    translate: translateType
  });
}
export const buttonsVehicleTypeService: any = vehicleTypesList;

export const languages = [
  { id: "it", name: "Italiano", webview_name: "IT", selected: false },
  { id: "fr", name: "Français", webview_name: "FR", selected: false },
  { id: "en", name: "English", webview_name: "EN", selected: false },
  { id: "de", name: "Deutsch", webview_name: "DE", selected: false }
];
